<script setup lang="ts">
import { onErrorCaptured, ref, watch } from "vue";
import { useRoute } from "vue-router";

import PageError from "@/components/PageError.vue";
import PageLoader from "@/components/PageLoader.vue";
import { HttpError } from "@/utils";

const route = useRoute();
const error = ref<HttpError | string | null>(null);

onErrorCaptured((e: Error) => {
  console.error("Captured error:", e); // ✅ Ajoute un log clair

  error.value = e instanceof HttpError ? e : (e as Error).message;

  if (import.meta.env.DEV) {
    console.trace(error);
    // console.error(error);
  }

  return true;
});

watch(route, () => {
  error.value = null;
});
</script>
<template>
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
      <PageError v-if="error" :error="error" />
      <Suspense v-else timeout="0">
        <component :is="Component" />
        <template #fallback>
          <PageLoader />
        </template>
      </Suspense>
    </template>
    <template v-else>
      <PageLoader />
    </template>
  </RouterView>
</template>
